import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import {EventUserInfo} from './models/user-info';
import {EventRegistrationService} from './services/event-registration.service';
import {DataStoreService} from 'app/shared/data-store/services/data-store.service';
import {map} from 'rxjs/operators';

@Component({
  selector: 'event-registration',
  templateUrl: './event-registration.component.html',
  styleUrls: ['./event-registration.component.css'],
})
export class EventRegistrationComponent implements OnInit {

  public userInfo: EventUserInfo;
  public error: string;
  private errorMap: {} = {
    'invalid code': 'Der Code ist ungültig',
    'invalid email': 'Die gewählte E-Mail Adresse ist ungültig',
    'email already exists': 'Die gewählte E-Mail Adresse existiert bereits',
    'firstname missing': 'Der Vorname muss angegeben werden',
    'lastname missing': 'Der Nachname muss angegeben werden',
  };

  constructor(private router: Router,
              private route: ActivatedRoute,
              private eventRegistrationService: EventRegistrationService,
              private dataStoreService: DataStoreService) {

    this.userInfo = {
      email: '',
      password: '',
      firstname: '',
      lastname: '',
      code: null,
      companyName: '',
    };
  }

  public ngOnInit(): void {
    this.route.params.pipe(map((params) => {
      return params;
    }))
      .subscribe((routeParams) => {
        this.userInfo.companyName = routeParams.company_name;
        if ( this.userInfo.companyName == 'Fuehrungsakademie_BW') { // fix for voucher link
          this.userInfo.companyName = 'FA_BW_ALL';
        }
      });

    this.route.queryParams.pipe(map((params) => {
      return params;
    }))
      .subscribe((queryParams) => {
        this.userInfo.code = queryParams.voucher_code;
        this.userInfo.eventName = queryParams.event_name;
      });
  }

  public onSubmit(): void {
    this.eventRegistrationService.register(this.userInfo)
      .subscribe(
        (result: string) => {
          this.dataStoreService.email = this.userInfo.email;
          this.router.navigateByUrl('/thank-you');
        },
        (error: Error) => {
          const message: string = error.message;

          if (this.errorMap[message]) {
            this.error = this.errorMap[message];
            return;
          }

          this.error = message;
        },
      );
  }
}
